import React from "react";
import { useNavigate } from "react-router-dom";

import FileUpload from "components/FileUpload/FileUpload";
import { Heading2 } from "widgets";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import FileUploadsHistory from "components/FileUploadsHistory/FileUploadsHistory";
import { UPDATE_OR_UPLOAD_PACKAGE_PAYMENT_HEAD_SCRIPT_ID } from "constants/constants";

import styles from "./UploadOrUpdatePackagePaymentHead.module.scss";

const handleOnClickGoBackButton = (navigate) => {
  navigate("/homePage");
};

const UploadOrUpdatePackagePaymentHead = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.mainContainer}>
      <div
        className={styles.backContainer}
        onClick={() => handleOnClickGoBackButton(navigate)}
      >
        <ArrowBackIosIcon className={styles.icon} />
        <span className={styles.text}>Back</span>
      </div>
      <Heading2 heading="Upload/Update Package Payment Heads" />
      <FileUpload
        scriptId={UPDATE_OR_UPLOAD_PACKAGE_PAYMENT_HEAD_SCRIPT_ID}
        uploadLabel="Upload/Update Package Payment Head"
      />
      <Heading2 heading="Recently Uploaded/Updated Package Payment Heads" />
      <FileUploadsHistory
        scriptId={UPDATE_OR_UPLOAD_PACKAGE_PAYMENT_HEAD_SCRIPT_ID}
      />
    </div>
  );
};
export default UploadOrUpdatePackagePaymentHead;
